export default __webpack_public_path__ + "static/media/plus-solid.72d79fa2.svg";